import React, { useState } from 'react';
import axios from 'axios';
import { API } from '../../lib/api';
import ModuleViewer from '../ModuleViewer';

const AdminSchulungenView = () => {
  const [categories, setCategories] = useState([]);
  const [expandedCat, setExpandedCat] = useState(null);
  const [modulesByCat, setModulesByCat] = useState({});
  const [loadingCat, setLoadingCat] = useState(null);
  const [loading, setLoading] = useState(true);
  const [previewModule, setPreviewModule] = useState(null);

  React.useEffect(() => {
    const fetchAll = async () => {
      try {
        const res = await axios.get(`${API}/categories`);
        setCategories(res.data || []);
      } catch (e) { console.error(e); }
      setLoading(false);
    };
    fetchAll();
  }, []);

  const toggleCat = async (catId) => {
    if (expandedCat === catId) {
      setExpandedCat(null);
      return;
    }
    setExpandedCat(catId);
    if (!modulesByCat[catId]) {
      setLoadingCat(catId);
      try {
        const res = await axios.get(`${API}/modules?category_id=${catId}`);
        setModulesByCat(prev => ({ ...prev, [catId]: res.data || [] }));
      } catch (e) {
        setModulesByCat(prev => ({ ...prev, [catId]: [] }));
      }
      setLoadingCat(null);
    }
  };

  if (loading) return <div className="flex justify-center py-16"><div className="animate-spin rounded-full h-10 w-10 border-b-2 border-indigo-600"/></div>;

  return (
    <div className="space-y-4">
      {/* Admin Preview Modal */}
      {previewModule && (
        <ModuleViewer
          module={previewModule}
          isOpen={true}
          onClose={() => setPreviewModule(null)}
          onComplete={() => setPreviewModule(null)}
          isPreviewMode={true}
        />
      )}
      <div>
        <h2 className="text-2xl font-bold text-slate-800">Schulungen – Übersicht</h2>
        <p className="text-slate-500 mt-1 text-sm">Alle Kategorien und Module wie sie Mitarbeiter sehen</p>
      </div>
      {categories.length === 0 ? (
        <div className="text-center py-16 text-gray-400">Noch keine Kategorien vorhanden.</div>
      ) : (
        <div className="space-y-3">
          {categories.map(cat => {
            const isOpen = expandedCat === cat.id;
            const modules = modulesByCat[cat.id] || [];
            const isLoadingModules = loadingCat === cat.id;
            const moduleCount = cat.modules_count ?? modules.length;
            return (
              <div key={cat.id} className="bg-white rounded-xl border border-gray-200 shadow-sm overflow-hidden">
                <button
                  onClick={() => toggleCat(cat.id)}
                  className="w-full flex items-center justify-between px-5 py-4 hover:bg-gray-50 transition-colors"
                >
                  <div className="flex items-center gap-3">
                    <div className="w-3 h-3 rounded-full flex-shrink-0" style={{ backgroundColor: cat.color || '#6366f1' }} />
                    <span className="font-semibold text-gray-800">{cat.title}</span>
                    <span className="text-xs text-gray-400 bg-gray-100 px-2 py-0.5 rounded-full">{moduleCount} Module</span>
                    <span className="text-xs text-indigo-600 bg-indigo-50 px-2 py-0.5 rounded-full">{cat.target_roles?.includes('teamleiter') ? 'Teamleiter' : 'Vertriebler'}</span>
                  </div>
                  <svg className={`w-5 h-5 text-gray-400 transition-transform ${isOpen ? 'rotate-180' : ''}`} fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7"/>
                  </svg>
                </button>
                {isOpen && (
                  <div className="border-t border-gray-100 divide-y divide-gray-50">
                    {isLoadingModules ? (
                      <div className="px-5 py-4 flex justify-center">
                        <div className="animate-spin rounded-full h-6 w-6 border-b-2 border-indigo-400"/>
                      </div>
                    ) : modules.length === 0 ? (
                      <p className="px-5 py-3 text-sm text-gray-400">Keine Module in dieser Kategorie.</p>
                    ) : modules.map(mod => (
                      <div
                        key={mod.id}
                        onClick={() => setPreviewModule(mod)}
                        className="flex items-center gap-3 px-5 py-3 hover:bg-indigo-50 cursor-pointer transition-colors group"
                        title="Klicken um Modul als Vorschau zu öffnen"
                      >                        <div className="w-8 h-8 rounded-lg bg-indigo-50 flex items-center justify-center flex-shrink-0">
                          {mod.content_type === 'video' ? (
                            <svg className="w-4 h-4 text-indigo-500" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M14.752 11.168l-3.197-2.132A1 1 0 0010 9.87v4.263a1 1 0 001.555.832l3.197-2.132a1 1 0 000-1.664z"/><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M21 12a9 9 0 11-18 0 9 9 0 0118 0z"/></svg>
                          ) : mod.content_type === 'pdf' ? (
                            <svg className="w-4 h-4 text-red-400" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"/></svg>
                          ) : (
                            <svg className="w-4 h-4 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2"/></svg>
                          )}
                        </div>
                        <div className="flex-1 min-w-0">
                          <p className="text-sm font-medium text-gray-800 truncate">{mod.title}</p>
                          {mod.description && <p className="text-xs text-gray-400 truncate">{mod.description}</p>}
                        </div>
                        <span className="text-xs text-gray-400 bg-gray-100 px-2 py-0.5 rounded flex-shrink-0">{mod.content_type?.toUpperCase()}</span>
                        <svg className="w-4 h-4 text-indigo-300 group-hover:text-indigo-500 flex-shrink-0 transition-colors" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 12a3 3 0 11-6 0 3 3 0 016 0z"/>
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z"/>
                        </svg>
                      </div>
                    ))}
                  </div>
                )}
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
};

export default AdminSchulungenView;
